export const DEFAULT_API_URLS = {
  AUTH_URL: "https://authentication.risalabs.ai/api/v1/user-auth",
  BACKEND_SERVICE: "https://apis.risalabs.ai/backend-service/",
} as const;

/**
 * Builds the full set of API endpoint URLs used by auth-wrapper services.
 *
 * @param config - Optional overrides for auth and backend base URLs
 * @returns Endpoint map including auth, RBAC, profile, and extension-pairing routes
 */
export function buildApiEndpoints(config?: {
  authUrl?: string;
  backendServiceUrl?: string;
}) {
  const authUrl = config?.authUrl ?? DEFAULT_API_URLS.AUTH_URL;
  const backendService =
    config?.backendServiceUrl ?? DEFAULT_API_URLS.BACKEND_SERVICE;

  return {
    BEARER_TOKEN_URL: `${authUrl}/token`,
    CHECK_RATE_LIMIT_PASSWORD_RESET: `${authUrl}/check-rate-limit-password-reset`,
    PAIRING_CODE: `${backendService}auth/extension/pairing-code`,
    AUTH_TOKEN: `${backendService}auth/token`,
    AUTH_VERIFY_TOTP: `${backendService}auth/verify-totp`,
    MEMBER_BASE: `${backendService}commons/rbac/members`,
    MEMBER_INVITE: `${backendService}commons/rbac/members/invite`,
    MEMBER_BULK_UPDATE: `${backendService}commons/rbac/members/bulk-update`,
    MEMBER_RESET_2FA: (userId: string) =>
      `${backendService}commons/rbac/members/${userId}/reset-2fa`,
    MEMBER_DELETE: (userId: string) =>
      `${backendService}commons/rbac/members/${userId}/global`,
    UPDATE_PROFILE: `${backendService}commons/profile/update`,
  } as const;
}

export type ApiEndpoints = ReturnType<typeof buildApiEndpoints>;
